import React from "react";
import vactor from "../../../assets/svg/500error.svg";

function InternalError() {
  // console.log(error,resetErrorBoundary,"ERROR")
  return (
    <div className="w-full h-screen flex flex-col  items-center justify-center ">
      <img
        src={vactor}
        className=" h-[70%] aspect-square object-contain "
        alt="error-vactor"
      />

      <div className=" text-center mt-2 ">
        <h1 className=" text-[32px]  font-bold  ">Internal error !</h1>
        <p className="text-lg text-[#6C757D]">
          We are working towards create something better Won’t be long
        </p>

        {/* <button
          className="btn-primary  font-medium w-[190px] mt-[30px]   "
          onClick={resetErrorBoundary}
        >
          Go back
        </button> */}
      </div>
    </div>
  );
}

export default InternalError;
